<div
  id="page-header"
  class="flex flex-col gap-4 md:flex-row md:items-center md:justify-between md:mb-6 md:min-h-[52px]"
>
  @if (!isMobile()) {
    <button
      id="page-header-back-button"
      type="button"
      class="flex items-center gap-2 text-ld-primary hover:text-ld-primary font-bold transition-colors cursor-pointer"
      (click)="onBackClick()"
    >
      <mat-icon class="w-4! h-4! text-[16px]!" aria-hidden="true">chevron_left</mat-icon>
      <span class="uppercase tracking-[0.5px] text-base">{{ backLabel() }}</span>
    </button>
  }

  @if (pageTitle()) {
    <h1 id="page-header-title" class="text-page-title">
      {{ pageTitle() }}
      @if (pageTitleHighlight()) {
        /
        <span class="text-ld-primary font-semibold">{{ pageTitleHighlight() }}</span>
      }
    </h1>
  }
</div>
